import React, { FC } from 'react';
import { Column, Row } from 'atoms/Layout';
import { RainbowColorPane } from 'atoms/Pane';
import MonitorImage from 'atoms/MonitorImage';
import Logo from 'atoms/Logo';

interface Props {
    children?: React.ReactNode;
}

const OnboardingLayout: FC<Props> = ({ children}) => {
    return <Row size="full">
        <Column size="full" padding="large" gap="medium">
            <Row padding="large">
                <Logo />
            </Row>
            {children}
        </Column>
        <Column size="full">
            <RainbowColorPane>
                <Column>
                    <MonitorImage />
                </Column>
            </RainbowColorPane>
        </Column>
    </Row>
}

export default OnboardingLayout;
